export default {
    path: '/contactdetail',
    meta: {
        title: '合同',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/contactdetail`),
}


// WEBPACK FOOTER //
// ./src/views/ContactDetail/router.js